// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "6794" ? "npm.crypto-pro" : chunkId) + "." + {"2840": "d28509d820798779","6794": "ada37b8652488c28","8833": "07ee0f19dd81fb8c","9918": "095fa71e28375163",}[chunkId] + ".js"
}